import React from 'react';
import { SubHeading, Text } from '../typography';
import { NotFound } from './Faq.style';

interface FaqNotFoundProps {
  noArticles?: boolean;
}

const FaqNotFound: React.FC<FaqNotFoundProps> = ({ noArticles }) => {
  return (
    <NotFound data-testid="faq-not-found">
      <SubHeading data-testid="faq-not-found-header" fontSize={32}>
        {noArticles ? 'No FAQ Articles' : 'FAQ Not Found'}
      </SubHeading>
      {noArticles ? (
        <Text data-testid="faq-no-articles">This FAQ Section has no articles.</Text>
      ) : (
        <>
          <Text>Oops! The page you are looking for does not exist.</Text>
          <Text>It might have been moved or deleted.</Text>
        </>
      )}
    </NotFound>
  );
};

export default FaqNotFound;
